<template>
    <div>
        <b-row class="mb-4">
            <b-col cols="12" md="6">
                <label>{{ $t('Beneficiary Name') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" :placeholder="$t('Name')" v-model="params.beneficiaryName" @keydown="onChange('beneficiaryName')"/>
                <div v-if="error['beneficiaryName']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryName'])}}
                </div>
            </b-col>

            <b-col cols="12" md="6">
                <label>{{ $t('ID Number') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="params.beneficiaryIdNo" @keydown="onChange('beneficiaryIdNo')"/>
                <div v-if="error['beneficiaryIdNo']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdNo'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="6">
                <label>{{ $t('Date of Birth') }} <span class="text-danger">*</span></label>
                <date-picker v-model="params.beneficiaryBirthDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('beneficiaryBirthDate')"></date-picker>
                <div v-if="error['beneficiaryBirthDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryBirthDate'])}}
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <label>{{ $t('Certificate Validity') }} <span class="text-danger">*</span></label>
                <date-picker v-model="params.beneficiaryCertExpiryDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('beneficiaryCertExpiryDate')"></date-picker>
                <div v-if="error['beneficiaryCertExpiryDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryCertExpiryDate'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="6" class="mb-3">
                <label>{{ $t('Type of Certificate') }} <span class="text-danger">*</span></label>
                <NewDocOption 
                    :data="doc_type_list"
                    :ref="'doc_type'"
                    @selected-document="selectedDocumentBeneficiary($event)">
                </NewDocOption>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Front Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(1)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(params.beneficiaryIdType==1?'ic':'passport')+'_front'" v-if="showPopup_1" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>

                <FileUploader  
                    :type="'browse'"
                    :ref="'id_photo_1'"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    :default_image="params.beneficiaryIdFront"
                    @capture-file="captureFile($event,'beneficiaryIdFront')" 
                    @remove-image="removeImage($event,'beneficiaryIdFront')"
                    @toggle-camera="toggleCamera($event)">
                </FileUploader>
                <div v-if="error['beneficiaryIdFront']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdFront'])}}
                </div>
            </b-col>

            <b-col cols="12" md="6" v-if="params.beneficiaryIdType == 1" class="mb-3">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Back Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(2)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(params.beneficiaryIdType==1?'ic':'passport')+'_national'" v-if="showPopup_2" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>
                <FileUploader  
                    :type="'browse'"
                    :ref="'id_photo_2'"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    :default_image="params.beneficiaryIdReverse"
                    @capture-file="captureFile($event,'beneficiaryIdReverse')" 
                    @remove-image="removeImage($event,'beneficiaryIdReverse')">
                </FileUploader>
                <div v-if="error['beneficiaryIdReverse']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdReverse'])}}
                </div>
            </b-col>

        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="4">
                <div class="form-group mb-0">
                    <label>{{ $t('Country') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="beneficiaryCountry" :options="countryOpt" @select="onSelectCountry($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Country")}' class="form-control"/>
                    <div v-if="error['beneficiaryCountry']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryCountry'])}}
                    </div>
                </div>
            </b-col>

            <b-col md="4" cols="12">
                <div class="form-group mb-0">
                    <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.beneficiaryProvince" :options="stateOpt" @select="onSelectState($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                    <div v-if="error['beneficiaryProvince']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryProvince'])}}
                    </div>
                </div>
            </b-col>

            <b-col md="4" cols="12">
                <div class="form-group mb-0">
                    <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                    <input type="text" maxlength="58" v-model="params.beneficiaryCity" name="beneficiaryCity" value="" :placeholder="$t('City')" class="form-control" @keydown="onChange('beneficiaryCity')" autocomplete=off>
                    <div v-if="error['beneficiaryCity']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryCity'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col xl="12">
                <div class="form-group mb-0">
                    <label>{{ $t('permanent address (detailed address)') }} <span class="text-danger">*</span></label>
                    <input type="text" name="beneficiaryAddress" v-model="params.beneficiaryAddress" class="form-control" @keydown="onChange('beneficiaryAddress')"/>
                    <div v-if="error['beneficiaryAddress']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryAddress'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Holdings ratio (%)') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <input type="text" class="form-control" :placeholder="$t('Please enter shareholding ratio')" v-model="params.beneficiaryShareholderRatio" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                <div v-if="error['beneficiaryShareholderRatio']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryShareholderRatio'])}}
                </div>
            </b-col>
        </b-row>
    </div>


</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import Common from '@/services/Common';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
    data() {
        return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            showPopup_1:false,
            showPopup_2:false,
            showPopup_3:false,
            lang_date:'en',
            maxSize:4,
            success:null,
            formData:{},
            beneficiaryCountry:'',
            countryOpt:[],
            stateOpt:[],
            optional:[],
            file:{
                beneficiaryIdFront:null,
                beneficiaryIdReverse:null
            },
            params:{
                beneficiaryIdType:'1',
                beneficiaryIdFront:'',
                beneficiaryIdReverse:'',
                beneficiaryIdNo:'',
                beneficiaryName:'',
                beneficiaryBirthDate:'',
                beneficiaryCertExpiryDate:'',
                beneficiaryCountry:'',
                beneficiaryProvince:'',
                beneficiaryCity:'',
                beneficiaryAddress:'',
                beneficiaryShareholderRatio:''
            },
            error:{
                beneficiaryIdType:'',
                beneficiaryIdFront:'',
                beneficiaryIdReverse:'',
                beneficiaryIdNo:'',
                beneficiaryName:'',
                beneficiaryBirthDate:'',
                beneficiaryCertExpiryDate:'',
                beneficiaryCountry:'',
                beneficiaryProvince:'',
                beneficiaryCity:'',
                beneficiaryAddress:'',
                beneficiaryShareholderRatio:''
            }
        }
    },
    components:{
        NewDocOption,
        FileUploader,
        Select2,
        NewPopupInfo,
        DatePicker
    },
    props:['doc_type_list','index','is_new','userNo','accountId'],
    methods:{
        geetAccountList(){
            let self = this;
            CreateAccount.list({
                search:self.search,
                start:0,
                length:-1
            }).then((response)=>{
                if (response.status == 200) {
                    self.formData = response.data.data[0]['information'];
            
                    Object.keys(this.params).forEach(function(key) {
                        if(typeof self.file[key]!=="undefined" && self.formData[key][self.index]){
                            self.file[key]=self.formData[key][self.index];
                            self.getFile(key,self.formData[key][self.index]);
                        }
                        else{
                            self.params[key]=self.formData[key][self.index];
                        }
                    });

                    // set country
                    for (let i = 0; i < this.countryOpt.length; i++) {
                        if(self.countryOpt[i]['iso3'] == self.params.beneficiaryCountry){
                            self.beneficiaryCountry = self.countryOpt[i]['id'];
                            break;
                        }
                    }

                    Common.states({"state_name":self.params['beneficiaryProvince']}).then(response => {
                        if(response.status == 200 && response.data.success){
                            const province = response.data.data;
                            for (let i = 0; i < province.length; i++) {
                                self.stateOpt.push({"id":province[i]['name'],"text":province[i]['name']});
                            }
                        }
                    });
                }
            });
        },
        getFile(index,file_id){
            let self = this;
            console.log(file_id);
            CreateAccount.getFile({fileId:file_id}).then(response => {
                let data_file = response.data.data[0];
                
                if(data_file.type == 2 || data_file.type == 5){
                    self.params.beneficiaryIdFront = data_file.file;
                }
                else if(data_file.type == 3){
                    self.params.beneficiaryIdReverse = data_file.file;
                }
            });
        },
        addressCondition($event){
            if($event.keyCode == 13){
                $event.preventDefault();
            }
            this.onChange('beneficiaryShareholderRatio');
        },
        onchangeAddress($event){
            let msg = $event.target.value.replace("\n", " ");
            $event.target.value = msg;
        },
        onSelectCountry({id,text,iso3}){
            var self = this;
            this.onChange('beneficiaryCountry');
            self.stateOpt = [];
            if(text){
                this.params.beneficiaryCountry = iso3;
                this.params.beneficiaryProvince="";
                this.params.beneficiaryCity="";
            }
            
            Common.states({"country_code":id}).then(response => {
                if(response.status == 200 && response.data.success){
                    const state = response.data.data;
                    for (let i = 0; i < state.length; i++) {
                    self.stateOpt.push({"id":state[i]['name'],"text":state[i]['name']});
                    }
                }
            });
        },
        onSelectState({id,text}){
            var self = this;
            this.onChange('beneficiaryProvince');
        },
        onChange(name){
            this.error[name]="";
        },
        validate(){
            let success = true;
            let self = this;
            Object.keys(this.params).forEach(function(key) {
                if(self.params.beneficiaryIdType==2 && key == "beneficiaryIdReverse"){
                    self.error[key]="";
                }
                else if(!self.params[key]&& !self.optional.includes(key)){
                    console.log(key+" can not blank");
                    self.error[key]="can not be blank.";
                    success = false;
                }
            });

            return success;
        },
        uploadFile(account){
            let self = this;
            this.success = null;
            
            this.error.beneficiaryIdFront='';
            this.error.beneficiaryIdReverse='';
            
            let fileList = [];


            if(self.params.beneficiaryIdFront.indexOf("base64")!=-1){
                fileList.push({
                    "type":(self.params.beneficiaryIdType==1)?2:5,
                    "maxSize":self.maxSize*1024*1024,
                    "file":self.params.beneficiaryIdFront
                });
            }

            if(self.params.beneficiaryIdType==1 && self.params.beneficiaryIdReverse.indexOf("base64")!=-1){
                fileList.push(
                    {
                        "type":3,
                        "maxSize":self.maxSize*1024*1024,
                        "file":self.params.beneficiaryIdReverse
                    }
                );
            }

            if(fileList.length>0){
                CreateAccount.uploadFile({
                    "accountId":self.accountId,
                    "userNo":""+self.userNo,
                    "fileUpload":fileList
                }).then(response => {
                    const data = response.data.data;
                    let fileList = data["file"];
                    for(let i=0;i<fileList.length;i++){
                        if(fileList[i].type==2 || fileList[i].type==5){
                            // self.params.beneficiaryIdFront = fileList[i].file;
                            self.file.beneficiaryIdFront = fileList[i].fileId;
                        }
                        else if(fileList[i].type==3){
                            // self.params.beneficiaryIdReverse = fileList[i].file;
                            self.file.beneficiaryIdReverse = fileList[i].fileId;
                        }
                    }
                    self.success = true;
                    self.$emit('file-uploaded');
                }).catch(err => {
                    self.checkError(err);
                });
            }
            else{
                self.success = true;
                self.$emit('file-uploaded');
            }
        },
        checkError(err){
            try{
                let self = this;
                const response = err.response;  
                if(response.status == 400){
                    if(typeof response.data.message === 'string'){
                        this.$notify({
                            type: 'warn',
                            text: response.data.message
                        });
                    }
                    else{
                        if(response.data.message['file']){
                            let fileList = response.data.message['file'];
                            for(let i=0;i<fileList.length;i++){
                                if(fileList[i].type==2 || fileList[i].type==5){
                                    self.error.beneficiaryIdFront=fileList[i].message;
                                }
                                else if(fileList[i].type==3){
                                    self.error.beneficiaryIdReverse=fileList[i].message;
                                }
                            }
                        }
                        self.success = false;
                        self.$emit('file-uploaded');
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }catch(e){
                console.log(err);
            }
        },
        togglePopup(index){
            this['showPopup_'+index]=!this['showPopup_'+index];
        },
        selectedDocumentBeneficiary(data){
            this.params.beneficiaryIdType = data.index+1;
            this.error.beneficiaryIdType = "";
        },
        captureFile($event,key) {
            this.error[key] = "";
            this.params[key] = $event;
        },
        removeImage($event,key){
            this.params[key]="";
            this.error[key] = "";
        },
        doEscapeMarkup(markup){
            return markup;
        }
    },
    mounted(){
        let self = this;
        Common.countries().then(response => {
          if(response.status == 200 && response.data.success){
            const countries=response.data.data;
  
            for (let i = 0; i < countries.length; i++) {
              const flag = '<span class="fi fi-'+countries[i]['iso2'].toLowerCase()+'"></span>';  
              const country_name = "<span>"+this.$t(countries[i]['name'])+"\t\t\t"+"</span>";
              
              self.countryOpt.push({"id":countries[i]['iso2'],"text":flag+country_name,"iso3":countries[i]['iso3']});
            }
            if(self.is_new === false){
                self.geetAccountList();
            }
          }
        });
    }
}
</script>